import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const CirclePlayIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75 10C2.75 5.99594 5.99594 2.75 10 2.75C14.0041 2.75 17.25 5.99594 17.25 10C17.25 14.0041 14.0041 17.25 10 17.25C5.99594 17.25 2.75 14.0041 2.75 10ZM10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.8325 5.16751 18.75 10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 5.16751 14.8325 1.25 10 1.25ZM9 8.26795L12 10L9 11.7321L9 8.26795ZM13.5 9.13397C14.1667 9.51887 14.1667 10.4811 13.5 10.866L9 13.4641C8.33333 13.849 7.5 13.3679 7.5 12.5981L7.5 7.40192C7.5 6.63212 8.33333 6.151 9 6.5359L13.5 9.13397Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
